import {
  TBooleanState,
} from '../../utils/boolean.ts';

const tooltip: Record<TBooleanState, string> = {
  nullish: 'All',
  true: 'True',
  false: 'False',
};

export default tooltip;
